import { getExtFile } from '@libs/get-ext-file';

export const normalizePreview = (id, data, isTour, isEstimate, hiddenColumns, hiddenTypes) => {
  if (!data) {
    return null;
  }

  const { src, user = {}, estimate = {} } = data;
  const { name, avatar } = user;
  const isPanorama = getExtFile(src) === 'xml';

  return {
    src,
    isPanorama,
    isTour,
    isEstimate,
    estimateData: {
      ...estimate,
      publish_id: id,
      hiddenColumns,
      hiddenTypes,
    },
    sharedUser: {
      name,
      avatar,
    },
  };
};
